import { render, staticRenderFns } from "./TableCompetencia.vue?vue&type=template&id=6f9acf9b"
import script from "./TableCompetencia.vue?vue&type=script&lang=js"
export * from "./TableCompetencia.vue?vue&type=script&lang=js"
import style0 from "./TableCompetencia.vue?vue&type=style&index=0&id=6f9acf9b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports